import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac'
import { Posts } from '@/features/posts'

const postsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  query: z.string().optional().catch(undefined),
  sortBy: z.string().optional().catch(undefined),
  sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
  sourceType: z
    .union([
      z.enum(['USER_CREATED', 'AUTO_SCRAPED', 'MANUAL_SCRAPED']),
      z.array(z.enum(['USER_CREATED', 'AUTO_SCRAPED', 'MANUAL_SCRAPED'])),
    ])
    .optional()
    .catch(undefined),
  approvalType: z
    .union([
      z.enum(['NOT_APPLICABLE', 'AUTO_APPROVED', 'MANUAL_APPROVED']),
      z.array(z.enum(['NOT_APPLICABLE', 'AUTO_APPROVED', 'MANUAL_APPROVED'])),
    ])
    .optional()
    .catch(undefined),
})

export const Route = createFileRoute('/_authenticated/posts/')({
  validateSearch: postsSearchSchema,
  beforeLoad: () => {
    const auth = useAuthStore.getState()
    if (!auth.auth.canAccess([PERMISSIONS.POSTS.READ])) {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: Posts,
})
